import { render } from "./GitHubButton.vue?vue&type=template&id=75f8fff4&scoped=true"
import script from "./GitHubButton.vue?vue&type=script&lang=js"
export * from "./GitHubButton.vue?vue&type=script&lang=js"

import "./GitHubButton.vue?vue&type=style&index=0&id=75f8fff4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f8fff4"]])

export default __exports__